import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchCourseDetails } from '../services/api';
import { isReviewEdited } from '../utils/isEdited';
import EditedTag from '../components/EditedTag';

export default function CourseDetailsPage() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);

  useEffect(() => {
    const loadCourse = async () => {
      const data = await fetchCourseDetails(id);
      setCourse(data);
    };
    loadCourse();
  }, [id]);

  if (!course) return <div>Loading...</div>;

  return (
    <div>
      <h1>{course.long_name}</h1>
      <p>{course.description}</p>
      <h2>Reviews</h2>
      <ul>
          {course.reviews.map((review) => (
            <li key={review.id}>
              {review.rating} / 5 - {review.content}
              {isReviewEdited(review) && <EditedTag />}
            </li>
          ))}
        </ul>
    </div>
  );
}
